import { render, staticRenderFns } from "./pickingTasksForm.vue?vue&type=template&id=bb5ceada&scoped=true&"
import script from "./pickingTasksForm.vue?vue&type=script&lang=js&"
export * from "./pickingTasksForm.vue?vue&type=script&lang=js&"
import style0 from "./pickingTasksForm.vue?vue&type=style&index=0&id=bb5ceada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5ceada",
  null
  
)

export default component.exports